import React from "react";
import { Link } from "react-router-dom";

interface Props {}

const SummaryStep: React.FC<Props> = () => (
  <>
    <p className="mb-4">
      Thank you for verifying your wallet - and for the donation - it’s much
      appreciated 🙏.
    </p>

    <p className="mb-4">
      You’re on your way to collaborating with other hotspot owners to build a
      smarter People’s Network.
    </p>

    <p className="mb-4">
      Our systems are monitoring the incoming transactions for the next 24
      hours, so once successfully processed, the wallet will show as verified by
      your workspace.
    </p>

    <p className="mb-4">
      Verification enables the collaboration that’s only possible between
      trusted hotspot owners.
    </p>

    <div className="flex-shrink-0 px-4 py-4 flex justify-end">
      <Link
        to="/workspace/wallets"
        className="ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-hotspotty-400 hover:bg-hotspotty-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-hotspotty-400 flex items-center disabled:opacity-50 disabled:cursor-default"
      >
        Go to wallets
      </Link>
    </div>
  </>
);

export default SummaryStep;
